import {setStore, getStore} from '@/utils/store'

const user = {
  state: {
    test1: getStore({name: 'test1', type: 'session'}) || [],
    appId: getStore({name: 'appId', type: 'session'}) || '',
    accessToken: getStore({name: 'accessToken', type: 'session'}) || '',
    isOwner: getStore({name: 'isOwner', type: 'session'}) || '',
    industryId: getStore({name: 'industryId', type: 'session'}) || '',
    projectId: getStore({name: 'projectId', type: 'session'}) || '',
    clientType: getStore({name: 'clientType', type: 'session'}) || ''
  },
  mutations: {
    SET_TEST: (state, data) => {
      setStore({name: 'test1', content: data, type: 'session'})
      state.test1 = data
    },
    SET_ACCESSTOKEN: (state, data) => {
      setStore({name: 'accessToken', content: data, type: 'session'})
      state.accessToken = data
    },
    SET_ISOWNER: (state, data) => {
      setStore({name: 'isOwner', content: data, type: 'session'})
      state.isOwner = data
    },
    SET_APPID: (state, data) => {
      setStore({name: 'appId', content: data, type: 'session'})
      state.appId = data
    },
    SET_INDUSTRYID: (state, data) => {
      setStore({name: 'industryId', content: data, type: 'session'})
      state.industryId = data
    },
    SET_PROJECTID: (state, data) => {
      setStore({name: 'projectId', content: data, type: 'session'})
      state.projectId = data
    },
    SET_CLIENTTYPE: (state, data) => {
      setStore({name: 'clientType', content: data, type: 'session'})
      state.clientType = data
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/common.js